import * as constants from 'actions/constants'
import { InteractionType } from 'types/interactions';
import { Profile } from 'types/user'

export interface FetchReducer {
  name: string
  // profile: Profile | null
  // latestProfiles: Profile[]
  // profiles: Map<string, Profile>

}
const defaultState: FetchReducer = {
  name: '',
  // profile: null, //USER TO BE SHOWN TO THE CURRENT USER
  // latestProfiles: [],
  // profiles: new Map()
}

let profileObject = null;
export default function fetchReducer(state = defaultState, action: any) {
  switch (action.type) {
   
    default:
      if (action?.response?.code === 'FORCE_LOGOUT_FRONTEND') return defaultState
      return state
  }
}
// const processSingleProfile = (key: any, value: any) => {

//   const profile: Profile = {
//     uid: key,
//     name: value.name,
//     email: value.email,
//     address: "",
//     mobile: "",
//     image: value.imageDownloadLink,
//     city: value.city,
//     country: value.country,
//   }

//   return profile
// }
// const processProfiles = (latestProfilesResponse: any, myUid: string) => {
//   let latestProfiles = []
//   for (const [key, value] of Object.entries(latestProfilesResponse).reverse() as any) {
//     latestProfiles.push(processSingleProfile(key, value))
//   }

//   return latestProfiles

// }